import { render, staticRenderFns } from "./AsideItemIcon.vue?vue&type=template&id=2065b584&scoped=true&"
import script from "./AsideItemIcon.vue?vue&type=script&lang=js&"
export * from "./AsideItemIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2065b584",
  null
  
)

export default component.exports